import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { IoMdArrowBack } from 'react-icons/io';
import OtpInput from 'react-otp-input';
import { useEffect } from 'react';

const Login = () => {
    const [username, setUsername] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [isOpen, setIsOpen] = React.useState(false)
    const [step, setStep] = React.useState(1)
    const [code, setCode] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");
    const [recoveryEmail, setRecoveryEmail] = React.useState('')

    const handleChange = (code) => setCode(code);

    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const reset = () => {
        setStep(1)
        setIsOpen(false)
        setCode('')
        setNewPassword('')
        setRecoveryEmail('')
    }

    const validate = () => {
        if (username === '' || password === '') {
            notify('Please fill all the fields')
            return false
        }

        return true
    }

    const handleReset = async (e) => {
        e.preventDefault()
        if (recoveryEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/)) {
            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/seller/forgotPassword', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: recoveryEmail.toLowerCase()
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        if (data.success) {
                            notify(data.message)
                            setStep(2)
                        }
                        else {
                            notify(data.message)
                        }
                    })
                    .catch(err => notify(err))

            }
            catch (error) {
                notify(error.message)
            }
        } else {
            notify('Please enter a valid email')
        }

    }

    const handleOtpSubmit = async (e) => {
        e.preventDefault()
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/seller/checkotp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: recoveryEmail.toLowerCase(),
                    otp: code
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    notify(data.message)
                    if (data.success) {
                        setStep(3)
                    }
                }
                )
                .catch(err => notify(err))
        }
        catch (error) {
            notify(error.message)
        }
    }

    const handleFinalReset = async (e) => {
        e.preventDefault()
        if (newPassword.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!@#$%^&*]{8,}$/)) {
            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/seller/changePassword', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: recoveryEmail.toLowerCase(),
                        password: newPassword
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        notify(data.message)
                        setIsOpen(false)
                        setStep(1)
                    }
                    )
                    .catch(err => notify(err))
            }
            catch (error) {
                notify(error.message)
            }
        } else {
            notify('Password must be at least 8 characters long and contain at least one letter and one number')
        }
    }

    const handleLogin = (e) => {
        e.preventDefault()
        console.log(username, password)
        if (validate()) {
            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/seller/login', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username,
                        password
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        notify(data)
                        if (data.success) {
                            localStorage.setItem('token', data.token)
                            localStorage.setItem('user', JSON.stringify(data.user))
                            window.location.href = '/inventory'
                        }
                        else {
                            notify(data.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        notify(err.message)
                    })
            }
            catch (err) {
                console.log(err)
                notify(err)
            }
        }
    }

    useEffect(() => {
        if (localStorage.getItem('token')) {
            window.location.href = '/'
        }
    }, [])



    return (
        <div className="h-screen bg-[url('/public/assets/plants-sketch.png')] bg-cover dark:bg-black dark:bg-none">
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div className='mt-8 justify-center items-center flex'>
                <div className='h-[557px] w-[600px] mx-2 rounded-3xl shadow-2xl bg-white bg-opacity-90 shadow-green-400 dark:bg-gray-900'>

                    <div className="mt-16 bg-white px-4  dark:bg-gray-900 sm:mx-auto sm:w-full sm:max-w-md sm:px-10">
                        <div className="">
                            <form className="space-y-6">
                                <div>
                                    <label htmlFor="email" className="block dark:text-white text-sm font-medium text-gray-700">Username</label>
                                    <div className="mt-1">
                                        <input id="email" type="text" data-testid="username" required="" className="block w-full appearance-none dark:text-black rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue="" onChange={e => setUsername(e.target.value)} />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-white">Password</label>
                                    <div className="mt-1"><input id="password" name="password" type="password" data-testid="password" autoComplete="current-password" required="" className="block w-full appearance-none rounded-md border border-gray-300 px-3 dark:text-black py-2 placeholder-gray-400 shadow-sm focus:border-yellow-500 focus:outline-none focus:ring-yellow-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue="" onChange={e => setPassword(e.target.value)} />
                                    </div>
                                </div>
                                <div className="flex items-center justify-end">
                                    <div className="text-sm">
                                        {

                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a className="font-medium text-yellow-600 hover:text-yellow-500 cursor-pointer" onClick={(e) => { e.preventDefault(); setIsOpen(true); }}> Forgot your password?</a>}
                                    </div>
                                </div>
                                <div>
                                    <button data-testid="login" type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-yellow-600 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-50" onClick={e => handleLogin(e)}>
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                            <svg className="h-5 w-5 text-yellow-500 group-hover:text-yellow-400" x-description="Heroicon name: solid/lock-closed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"></path>
                                            </svg>
                                        </span>
                                        Sign in
                                    </button>
                                </div>
                            </form>
                            {/* <div className="mt-6">
                                <div className="relative">
                                    <div className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-300"></div>
                                    </div>
                                    <div className="relative flex justify-center text-sm"><span className="bg-white dark:bg-gray-900 px-2 text-gray-500">Or continue with</span></div>
                                </div>
                                <div className="mt-6 grid grid-cols-1 gap-3">
                                    <div>
                                        <button className="inline-flex w-full items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50 disabled:cursor-wait disabled:opacity-50  dark:bg-gray-700 dark:hover:bg-gray-800 dark:border-gray-600 " data-testid="google-oauth-btn">
                                            <span className="sr-only">Sign in with Google</span>
                                            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                                <clipPath id="p.0">
                                                    <path d="m0 0l20.0 0l0 20.0l-20.0 0l0 -20.0z" clipRule="nonzero"></path>
                                                </clipPath>
                                                <g clipPath="url(#p.0)">
                                                    <path fill="currentColor" fillOpacity="0.0" d="m0 0l20.0 0l0 20.0l-20.0 0z" fillRule="evenodd"></path>
                                                    <path fill="currentColor" d="m19.850197 8.270351c0.8574047 4.880001 -1.987587 9.65214 -6.6881847 11.218641c-4.700598 1.5665016 -9.83958 -0.5449295 -12.08104 -4.963685c-2.2414603 -4.4187555 -0.909603 -9.81259 3.1310139 -12.6801605c4.040616 -2.867571 9.571754 -2.3443127 13.002944 1.2301085l-2.8127813 2.7000687l0 0c-2.0935059 -2.1808972 -5.468274 -2.500158 -7.933616 -0.75053835c-2.4653416 1.74962 -3.277961 5.040613 -1.9103565 7.7366734c1.3676047 2.6960592 4.5031037 3.9843292 7.3711267 3.0285425c2.868022 -0.95578575 4.6038647 -3.8674583 4.0807285 -6.844941z" fillRule="evenodd"></path>
                                                    <path fill="currentColor" d="m10.000263 8.268785l9.847767 0l0 3.496233l-9.847767 0z" fillRule="evenodd"></path>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                            </div> */}
                            <div className="m-auto mt-6 w-fit md:mt-8"><span className="m-auto">Don't have an seller account? <Link className="font-semibold text-yellow-600" to="/register-seller">Create one</Link></span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='absolute  w-full'>
                <SmallFooter />
            </div>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => { setIsOpen(false); reset() }}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl dark:bg-black bg-white p-6 text-left align-middle shadow-xl transition-all dark:shadow-gray-700">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 dark:text-white text-gray-900 flex items-center gap-7"
                                    >
                                        {step !== 1 && <IoMdArrowBack className='cursor-pointer hover:text-green-600' onClick={() => setStep(step - 1)} />}
                                        <span>Recover Password</span>
                                    </Dialog.Title>
                                    {step === 1 && <form className="mt-4 space-y-4 lg:mt-5 md:space-y-5" action="#">
                                        <div>
                                            <label htmlFor="email" className="block text-sm font-medium dark:text-white text-gray-700">Email address </label>
                                            <div className="mt-1"><input id="email" type="text" data-testid="username" required="" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue="" onChange={e => setRecoveryEmail(e.target.value)} /></div>
                                        </div>

                                        <div>
                                            <button data-testid="login" type="submit" className="group relative flex w-full justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-50" onClick={(e) => handleReset(e)}>
                                                Reset Password
                                            </button>
                                        </div>
                                    </form>}
                                    {
                                        step === 2 && <div>
                                            <p className="mt-4 text-sm dark:text-gray-300 text-gray-500">
                                                To continue, complete this verification step. We've sent an OTP to the email <span className='text-green-500'>{recoveryEmail}</span>. Please enter it below to complete verification.
                                            </p>
                                            <p className='text-center text dark:text-gray-100 font-medium text-gray-700 mt-5'>Enter OTP</p>
                                            <div className='mt-2 items-center justify-center flex w-full '>

                                                <OtpInput
                                                    value={code}
                                                    onChange={handleChange}
                                                    numInputs={6}
                                                    separator={<span style={{ width: "4px" }}></span>}
                                                    isInputNum={true}
                                                    shouldAutoFocus={true}
                                                    inputStyle={{
                                                        border: "2px solid gray",
                                                        borderRadius: "8px",
                                                        width: "40px",
                                                        height: "40px",
                                                        fontSize: "18px",
                                                        color: "#000",
                                                        fontWeight: "400",
                                                        caretColor: "blue"
                                                    }}
                                                    focusStyle={{
                                                        border: "1px solid green",
                                                        outline: "none"
                                                    }}
                                                />
                                            </div>
                                            <div className='justify-center flex'>
                                                <button data-testid="login" type="submit" className="relative mt-3 flex justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-50" onClick={(e) => handleOtpSubmit(e)}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    }

                                    {
                                        step === 3 && <div>

                                            <p className=' text font-medium dark:text-gray-100 text-gray-700 mt-5'>Enter New Password</p>
                                            <div className='mt-2 items-center justify-center flex w-full '>
                                                <input type="password" data-testid="username" required="" className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" defaultValue="" onChange={e => setNewPassword(e.target.value)} />
                                            </div>
                                            <div className='flex justify-center'>
                                                <button data-testid="login" type="submit" className="relative mt-3 flex justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-50" onClick={(e) => handleFinalReset(e)}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>

                                    }
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default Login